<template>
  <div :class="className" @click="$emit('onClickStatusTag')">
    {{ trans(label) }}
  </div>
</template>

<script>
import translation from '@elements/translation';

export default {
  mixins: [ translation ],
  props: {
    label: { type: String, required: true },
    color: { type: String, default: 'gray' },
  },
  computed: {
    className() {
      return `status-label color-${this.color}`;
    },
  },
};
</script>
